export default __webpack_public_path__ + "static/media/review1.b33eb3c5.jpg";